// A SIGN-OFF'S TIMES IN THREE ZONES (owner 2026-11-01): UTC, US Eastern and US Central, by
// the zones' own names for that day (EST/EDT, CST/CDT) - the page's copy of
// back/utils/signoffTimes.js, so the certificate on screen and in the PDF read the same.
const ZONES = ["UTC", "America/New_York", "America/Chicago"];

function inZone(d, timeZone, withDate) {
  const opt = { hour: "numeric", minute: "2-digit", timeZone, timeZoneName: "short" };
  if (withDate) Object.assign(opt, { year: "numeric", month: "short", day: "numeric" });
  return new Date(d).toLocaleString("en-US", opt);
}

/** "Nov 1, 2026, 2:05 PM UTC · 9:05 AM EST · 8:05 AM CST"; "" for no date. */
export function threeZones(d) {
  if (!d || Number.isNaN(new Date(d).getTime())) return "";
  return ZONES.map((tz, i) => inZone(d, tz, i === 0)).join(" · ");
}

/** A picked calendar day: "Nov 1, 2026". */
export function dayOnly(d) {
  if (!d || Number.isNaN(new Date(d).getTime())) return "";
  return new Date(d).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric", timeZone: "UTC" });
}
